

function Cancel(){
    return(
        <h1>You have canceled your payment to Stripe!</h1>
    )
}

export default Cancel;